__turbopack_context__.v({
  "quick-links-block": "vxUkgW_quick-links-block",
  "quick-links-block--blue": "vxUkgW_quick-links-block--blue",
  "quick-links-block--gold": "vxUkgW_quick-links-block--gold",
  "quick-links-block__button": "vxUkgW_quick-links-block__button",
  "quick-links-block__label": "vxUkgW_quick-links-block__label",
  "quick-links-block__link": "vxUkgW_quick-links-block__link",
  "quick-links-block__links": "vxUkgW_quick-links-block__links",
  "quick-links-block__links-container": "vxUkgW_quick-links-block__links-container",
  "quick-links-block__links-container--mobile-expanded": "vxUkgW_quick-links-block__links-container--mobile-expanded",
  "quick-links-block__next": "vxUkgW_quick-links-block__next",
  "quick-links-block__prev": "vxUkgW_quick-links-block__prev",
  "quick-links-block__separator": "vxUkgW_quick-links-block__separator",
  "quick-links-block__toggle-expand": "vxUkgW_quick-links-block__toggle-expand",
  "quick-links-block__toggle-expand--active": "vxUkgW_quick-links-block__toggle-expand--active",
});
